// supplier api
import loadJsonAwsApiGenerator from './loadJsonAwsApiGenerator.api.supplier';

const getSupplierDashboardApi = loadJsonAwsApiGenerator('dashboard');

export default getSupplierDashboardApi;
